import { isCustomizationFeatureEnabled } from '../../handoff-metrics/handoff-metrics-helpers';
import {
  digitalFormsCountMetric,
  digitalFormsDigitizedFormMetric,
} from '../../handoff-metrics/metrics/digital-forms';
import { UnifyMetricDefinition, UnifyMetricEvalContext } from '../unify-metrics.types';
import { adaptHandoffMetric } from './adapt-handoff-metric';

const shouldSkipForms = (ctx: UnifyMetricEvalContext) =>
  !isCustomizationFeatureEnabled('Forms', ctx.features);

export const digitalFormsSubmittedMetricDef: UnifyMetricDefinition = {
  id: 'digital_forms_submitted',
  name: 'Digital forms submitted',
  sectionName: 'Digital Forms',
  allowExceptions: true,
  shouldSkip: shouldSkipForms,
  criteria: [adaptHandoffMetric(digitalFormsDigitizedFormMetric)],
};

export const formCreatedMetricDef: UnifyMetricDefinition = {
  id: 'form_created',
  name: 'Form created',
  sectionName: 'Digital Forms',
  allowExceptions: true,
  shouldSkip: shouldSkipForms,
  criteria: [adaptHandoffMetric(digitalFormsCountMetric)],
};
